import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  fetchTeamChatbots,
  fetchRoomTeamChatbots,
  createTeamChatbot,
  updateTeamChatbot,
  deleteTeamChatbot,
} from '@/api/teamChatbot'

export const fetchTeamChatbotsByTeam = createAsyncThunk(
  'teamChatbot/fetchByTeam',
  async (teamId: number, thunkAPI) => {
    try {
      const response = await fetchTeamChatbots(teamId)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const fetchTeamChatbotsByRoom = createAsyncThunk(
  'teamChatbot/fetchByRoom',
  async (roomId: string, thunkAPI) => {
    try {
      const response = await fetchRoomTeamChatbots(roomId)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const createNewTeamChatbot = createAsyncThunk(
  'teamChatbot/create',
  async (
    {
      teamId,
      assignmentData,
    }: {
      teamId: number
      assignmentData: { chatbot?: string; base_chatbot: string }
    },
    thunkAPI
  ) => {
    try {
      const response = await createTeamChatbot(teamId, assignmentData)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const updateExistingTeamChatbot = createAsyncThunk(
  'teamChatbot/update',
  async (
    {
      assignmentId,
      assignmentData,
    }: {
      assignmentId: number
      assignmentData: { chatbot?: string }
    },
    thunkAPI
  ) => {
    try {
      const response = await updateTeamChatbot(assignmentId, assignmentData)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const deleteExistingTeamChatbot = createAsyncThunk(
  'teamChatbot/delete',
  async (assignmentId: number, thunkAPI) => {
    try {
      await deleteTeamChatbot(assignmentId)
      return assignmentId
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)
